import { render, staticRenderFns } from "./managerDetail.vue?vue&type=template&id=dfc7eb10&scoped=true&"
import script from "./managerDetail.vue?vue&type=script&lang=js&"
export * from "./managerDetail.vue?vue&type=script&lang=js&"
import style0 from "./managerDetail.vue?vue&type=style&index=0&id=dfc7eb10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc7eb10",
  null
  
)

export default component.exports